import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { SiteShell } from "@/components/layout/SiteShell";

function App() {
  return (
    <BrowserRouter>
      <SiteShell />
    </BrowserRouter>
  );
}

export default App;
